import { render } from "./FaqList.vue?vue&type=template&id=9e7d6ba6&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"

import "./FaqList.vue?vue&type=style&index=0&id=9e7d6ba6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e7d6ba6"

export default script

/* vue-cli-plugin-import-components */
import BaseButton from "@/components/BaseButton.vue";
import FaqListItem from "@/components/FaqListItem.vue";
script.components = Object.assign({}, { BaseButton, FaqListItem }, script.components);